export default __webpack_public_path__ + "static/0253-f756e68f744e7121a12a761742fc935f.png";